import React, { useEffect, useState } from "react";
import {
    StyledIcon,
    StyledIndexesAndLength,
    StyledItemsPage,
    StyledPaginationLocal,
} from "../styles/components/PaginationLocalStyles";
import { LeftArrowIcon, RightArrowIcon } from "./Icons";

interface PaginationLocalProps {
    items: any[];
    itemsPage: number;
    onPaginate: (items: any[]) => void;
    hidePagination?: boolean;
}

function PaginationLocal({
    items,
    itemsPage,
    onPaginate,
    hidePagination = true,
}: PaginationLocalProps) {
    const [currentPage, setCurrentPage] = useState(0);
    const [paginatedItems, setPaginatedItems] = useState<any[]>([]);

    const totalPages = Math.ceil(items.length / itemsPage);
    const startIndex = currentPage * itemsPage;
    const endIndex = startIndex + itemsPage;

    const enabledColor = "#9654FF";
    const disabledColor = "#C4A0FF";

    const handleClickLeft = () => {
        if (currentPage > 0) setCurrentPage(currentPage - 1);
    };

    const handleClickRigth = () => {
        if (currentPage + 1 < totalPages) setCurrentPage(currentPage + 1);
    };

    const paginate = () => {
        const pageItems = items.slice(startIndex, endIndex);
        if (!pageItems.length && currentPage > 0) {
            setCurrentPage(0);
        } else {
            setPaginatedItems(pageItems);
        }
    };

    const handleDisplayPagination = () => {
        let display = "flex";

        if (hidePagination) {
            if (items.length && items.length > itemsPage) {
                display = "flex";
            } else {
                display = "none";
            }
        }

        return display;
    };

    useEffect(() => {
        paginate();
    }, [items]);

    useEffect(() => {
        paginate();
    }, [currentPage]);

    useEffect(() => {
        onPaginate(paginatedItems);
    }, [paginatedItems]);

    return (
        <StyledPaginationLocal
            style={{
                display: handleDisplayPagination(),
            }}
        >
            <StyledItemsPage>
                {`Itens por página: ${itemsPage}`}
            </StyledItemsPage>
            <StyledIndexesAndLength>
                {`${startIndex + 1}-${
                    endIndex > items.length ? items.length : endIndex
                } de ${items.length}`}
            </StyledIndexesAndLength>
            <StyledIcon>
                <LeftArrowIcon
                    style={{
                        cursor: currentPage === 0 ? "default" : "pointer",
                        fill: currentPage === 0 ? disabledColor : enabledColor,
                    }}
                    onClick={handleClickLeft}
                />
            </StyledIcon>
            <StyledIcon>
                <RightArrowIcon
                    style={{
                        cursor:
                            currentPage + 1 < totalPages
                                ? "pointer"
                                : "default",
                        fill:
                            currentPage + 1 < totalPages
                                ? enabledColor
                                : disabledColor,
                    }}
                    onClick={handleClickRigth}
                />
            </StyledIcon>
        </StyledPaginationLocal>
    );
}

export default PaginationLocal;
